import { useState } from "react";
import { Bar, BarChart, CartesianGrid, Cell, ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

import { COLORS } from "@/components/prospect/common";

const TAG_COLORS = { green: "#16a34a", yellow: "#eab308", pink: "#ec4899", red: "#dc2626", grey: "#94a3b8", none: "#cbd5e1" };
const LEGEND = [["green", "Rendez-vous"], ["yellow", "Rappel"], ["pink", "Autre produit"], ["red", "Pas intéressé"], ["grey", "Autre"]];

export const TagChart = ({ tags }) => (
  <section className="st-card" data-testid="st-tags-chart">
    <h3>Résultats d'appel par tag</h3>
    <div className="st-legend">{LEGEND.map(([c, l]) => <span key={c}><i style={{ background: TAG_COLORS[c] }} />{l}</span>)}</div>
    {!tags.length ? <p className="ck-muted">Aucun appel sur la période.</p> : (
      <ResponsiveContainer width="100%" height={Math.max(160, tags.length * 30)}>
        <BarChart data={tags} layout="vertical" margin={{ left: 10, right: 20 }}>
          <XAxis type="number" allowDecimals={false} tick={{ fontSize: 11 }} />
          <YAxis type="category" dataKey="tag" width={150} tick={{ fontSize: 12 }} />
          <Tooltip formatter={(v) => [`${v} appel(s)`, "Appels"]} />
          <Bar dataKey="count" radius={[0, 6, 6, 0]}>{tags.map((t) => <Cell key={t.tag} fill={TAG_COLORS[t.color]} />)}</Bar>
        </BarChart>
      </ResponsiveContainer>
    )}
  </section>
);

export const HourChart = ({ hours }) => {
  const best = [...hours].filter((h) => h.calls >= 3).sort((a, b) => b.rate - a.rate).slice(0, 2);
  return (
    <section className="st-card" data-testid="st-hours-chart">
      <h3>Activité par heure</h3>
      <p className="ck-muted" data-testid="st-best-slots">{best.length ? `Meilleurs créneaux de joignabilité : ${best.map((h) => `${h.hour} (${h.rate} %)`).join(", ")}` : "Pas encore assez d'appels pour dégager un créneau."}</p>
      <ResponsiveContainer width="100%" height={240}>
        <ComposedChart data={hours} margin={{ right: 10 }}>
          <CartesianGrid stroke="#f1ede8" vertical={false} />
          <XAxis dataKey="hour" tick={{ fontSize: 11 }} />
          <YAxis yAxisId="n" allowDecimals={false} tick={{ fontSize: 11 }} />
          <YAxis yAxisId="r" orientation="right" domain={[0, 100]} unit="%" tick={{ fontSize: 11 }} />
          <Tooltip formatter={(v, n) => (n === "rate" ? [`${v} %`, "Joignabilité"] : [v, n === "calls" ? "Appels passés" : "Décrochés"])} />
          <Bar yAxisId="n" dataKey="calls" fill="#fed7aa" radius={[6, 6, 0, 0]} />
          <Bar yAxisId="n" dataKey="answered" fill="#e8603c" radius={[6, 6, 0, 0]} />
          <Line yAxisId="r" dataKey="rate" stroke="var(--text)" strokeWidth={2} dot={{ r: 3 }} />
        </ComposedChart>
      </ResponsiveContainer>
    </section>
  );
};

export const FileYield = ({ files }) => {
  const [all, setAll] = useState(false);
  return (
  <section className="st-card" data-testid="st-files">
    <h3>Rendement des fichiers de prospection</h3>
    {!files.length ? <p className="ck-muted">Aucun fichier.</p> : (all ? files : files.slice(0, 5)).map((f) => (
      <div key={f.file_id} className="st-file" data-testid={`st-file-${f.file_id}`}>
        <div className="st-file-head"><strong>{f.name}</strong><span>{f.called.toLocaleString("fr-FR")} / {f.total.toLocaleString("fr-FR")} appelées ({f.total ? Math.round((100 * f.called) / f.total) : 0} %) · {f.called_period} sur la période{f.agent_name ? ` · ${f.agent_name}` : ""}</span></div>
        <div className="st-strip">{COLORS.map(([k, l, , c]) => (f.colors[k] ? <i key={k} title={`${l} : ${f.colors[k]}`} style={{ width: `${(100 * f.colors[k]) / f.total}%`, background: k === "blanc" ? "#e2e8f0" : c }} /> : null))}</div>
      </div>
    ))}
    {files.length > 5 && <button type="button" className="pl-link" onClick={() => setAll(!all)} data-testid="st-files-toggle">{all ? "Réduire" : `Voir les ${files.length} fichiers`}</button>}
  </section>
  );
};
